import * as BenchlingUtil from 'BenchlingUtil';
import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import notifications from 'notifications';
import {assaySchemaURL} from 'results/assay-schemas/AssaySchemaDAO';
import {dispatchAssaySchemaFetched} from 'results/AssaySchemaActions';

import * as RunSchemaDAO from './RunSchemaDAO';

export async function duplicateRunSchema({
  schemaId,
  name,
  sqlIdentifier,
  sessionId,
  isSpecJsonFormat,
  excludedInputFileConfigs,
  excludedOutputFileConfigs,
}: {
  schemaId: string;
  name: string;
  sqlIdentifier: string | null;
  sessionId: string;
  isSpecJsonFormat: boolean;
  excludedInputFileConfigs: Array<string>;
  excludedOutputFileConfigs: Array<string>;
}): Promise<void> {
  await RunSchemaDAO.duplicateRunSchema({
    schemaId,
    name,
    sqlIdentifier,
    sessionId,
    excludedInputFileConfigs,
    excludedOutputFileConfigs,
  })
    .then((response) => {
      const {runSchema} = response;
      dispatchAssaySchemaFetched(runSchema);
      BenchlingUtil.navigate(
        null,
        assaySchemaURL(LegacyAssaySchemaType.ASSAY_RUN, runSchema.id, isSpecJsonFormat)
      );
    })
    .catch((error) => {
      if (error?.responseJSON?.errors) {
        const message = `Invalid Spec: ${error?.responseJSON?.errors[0]}`;
        notifications.error(message);
      } else {
        notifications.notifyError(error);
      }
    });
}
